import { AccessReviewReason, IAccessReviewRow } from "types/User";

const DAY_MS = 24 * 60 * 60 * 1000;

// CLE-2765: the reason column in plain words. INACTIVE gets the day count filled in.
export const ACCESS_REVIEW_REASON_TEXT: Record<AccessReviewReason, string> = {
  INACTIVE: "No activity for {days} days",
  EMAIL_SUPPRESSED: "Email address bounced",
};

export const NOT_REMOVED_AUTOMATICALLY =
  "Needs a decision — not removed automatically";

export function reasonText(
  row: Pick<IAccessReviewRow, "accessReviewReason" | "lastSeenAt">,
  now: Date = new Date()
) {
  const template = ACCESS_REVIEW_REASON_TEXT[row.accessReviewReason] ?? "";
  const days = Math.floor(
    (now.getTime() - new Date(row.lastSeenAt).getTime()) / DAY_MS
  );
  return template.replace("{days}", String(days));
}

// A user in several hospitals is listed under the first one; the rest are named in the row.
export function hospitalGroupName(accounts: IAccessReviewRow["accounts"]) {
  return accounts[0]?.name ?? "No hospital";
}

export function otherHospitalNames(accounts: IAccessReviewRow["accounts"]) {
  return accounts.slice(1).map((account) => account.name);
}
